<app-form-select-typeahead
  (optionSelected)="onOptionSelected($event)"
  (searched)="onSearch($event)"
  [appQmSanitise]="'encrypt'"
  [options]="(addressOptions$ | async) ?? []"
  [placeholder]="'ADDRESS_ID_PLACEHOLDER' | translate"
  [setValueOnSelection]="false"
/>
